function TechTab({ icon: Icon, label, curOpen, onOpen }) {
  const isOpen = label === curOpen;

  return (
    <button
      className={`tech-tab ${isOpen ? "tech-tab--active" : ""}`}
      type="button"
      onClick={() => onOpen(label)}
    >
      <Icon size={17} />
      <span>{label}</span>
    </button>
  );
}

export default TechTab;
